import React from 'react';
import Barcode from 'react-barcode';

import logo from 'url:./benjerrys-white.svg';
import { useFlipOIDC } from '../../components/FlipOIDC';

export interface CardProps {
  title: string;
  prefix?: string;
  className?: string;
}

export default function Card({ className, title, prefix = 'FF' }: CardProps) {
  const { user } = useFlipOIDC();

  const [id, setId] = React.useState('');

  React.useEffect(() => {
    async function generateId() {
      const encoder = new TextEncoder();
      const data = encoder.encode(user.name);
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const value = hashArray.map((b) => String(b)).join('');
      setId(value.substring(0, 7));
    }

    generateId();
  }, [user]);

  return (
    <div className={className}>
      <div className="benjerrys-card-header">
        <div className="benjerrys-card-header-logo">
          <img src={logo} alt="Ben & Jerry's" />
        </div>
        <div className="benjerrys-card-header-title">
          {title}
        </div>
      </div>
      <div className="benjerrys-card-image" />
      <div className="benjerrys-card-text">
        For an extra drizzle of euphoria on every cone
      </div>
      <div className="benjerrys-card-barcode-spacing">
        <div className="benjerrys-card-barcode">
          <div className="benjerrys-card-barcode-code">
            <Barcode value={`${prefix}${id}`} width={2} displayValue={false} height={50} />
          </div>
          <div className="benjerrys-card-barcode-text">
            {`Member No. ${prefix}${id}`}
          </div>
        </div>
      </div>
      <div className="benjerrys-card-spacer" />
    </div>
  );
}
